module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-analytic-4.d1e17c11.svg";